import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Resources"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "resources"
    }}>{`Resources`}</h1>
    <p>{`Tools, themes, extensions and examples built by the Theme UI community. `}</p>
    <h2 {...{
      "id": "custom-themes"
    }}>{`Custom themes`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/tabetalt/kit"
        }}><strong parentName="a">{`@tabetalt/kit`}</strong></a>{`:
Used in Tabetalt’s e-commerce platform.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://theme.hackclub.com"
        }}><strong parentName="a">{`@hackclub/theme`}</strong></a>{`:
Used on `}<a parentName="li" {...{
          "href": "https://hackclub.com/"
        }}>{`Hack Club’s`}</a>{` websites.`}</li>
    </ul>
    <h2 {...{
      "id": "component-kits"
    }}>{`Component kits`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/ccontrols/component-controls/tree/master/ui/components"
        }}><strong parentName="a">{`@component-controls/components`}</strong></a>{`:
Components built for Theme UI.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/cartolab-gis/elements"
        }}><strong parentName="a">{`@cartolab/elements`}</strong></a>{`:
Themeable React components for map-based web applications.`}</li>
    </ul>
    <h2 {...{
      "id": "other-projects"
    }}>{`Other projects`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/samjbmason/theme-ui-native"
        }}><strong parentName="a">{`theme-ui-native`}</strong></a>{`:
Theme UI adapted for React Native projects.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/nandorojo/dripsy"
        }}><strong parentName="a">{`Dripsy`}</strong></a>{`: A responsive, theme-based design system for Expo + React Native Web.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/LekoArts/figma-theme-ui"
        }}><strong parentName="a">{`Theme UI plugin for Figma`}</strong></a>{`:
`}<a parentName="li" {...{
          "href": "https://www.figma.com/c/plugin/797015796747379907"
        }}>{`Figma plugin`}</a>{` to convert a Theme UI config to Figma Styles.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      